export class AddProductModel {
    Id: string;
    ProductName: string;
    ProductTitle: string;
    CategoryIds: string;
    CompanyAddressId: string;
    Price: number;
    Discount: number;
    IsShowDiscount: string;
    IsJustAdded: string;
    IsSale: string;
    IsQuote: string;
    IsShowDiscountValue: string;
    Features: string;
    Description: string;
    SearchTags: string;
    CategoryNames: string;
    Length: string;
    Width: string;
    Height: string;
    Weight: string;
    Title: string;
    IsActive: string;
    IsShippingRequired : string;
    GetSearchTags:string[];
    searchTags: any;
    ProductType: number;
    IsAccessories: string;
}

export class AddProductVm {
    Id: string;
    ProductName: string;
    ProductTitle: string;
    CategoryIds: string;
    CompanyAddressId: string;
    Price: number;
    Discount: number;
    IsShowDiscount: string;
    IsJustAdded: string;
    IsSale: string;
    IsQuote: string;
    IsShippingRequired: string = "1";
    IsShowDiscountValue: string;
    Features: string;
    Description: string;
    SearchTags: string;
    CategoryNames: string;
    Length: string;
    Width: string;
    Height: string;
    Weight: string;
    Title: string;
    IsActive: string;
    ProductType: number;
    IsAccessories: string;
}

export class UpdateProductModel {
    Id: string;
    ProductName: string;
    ProductTitle: string;
    CategoryIds: string;
    CompanyAddressId: string;
    Price: number;
    Discount: number;
    IsShowDiscount: boolean;
    IsShowDiscountValue: string;
    Features: string;
    Description: string;
    SearchTags: string;
    CategoryNames: string;
    Length: string;
    Width: string;
    Height: string;
    Weight: string;
    ProductType: number;
}

export class SearchTagsModel {
    Keyword: string;
}

export class SearchTagsResponseModel {
    searchTags: string;
}

export class SearchTagsArrayList {
    searchTagsAllList: Array<SearchTagsResponseModel> = [];
}
